// extracted by mini-css-extract-plugin
export default {"linkList":"button-module__linkList__PZYrE","editModule":"button-module__editModule__T4-N+"};